import React, { SFC } from "react";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";

type PropsType = WithContentWrapProps &
    HTMLProps<HTMLImageElement> &
    WithVerticalSpacingProps & {
        title?: string;
        src?: string;
        srcSet?: string;
        sizes?: string;
    };

const Image = (props: PropsType): SFC => {
    const sizes = props.sizes === undefined ? "100vw" : props.sizes;

    return props.srcSet === undefined ? (
        <img id={props.id} className="Image" src={props.src} alt={props.title} />
    ) : (
        <img id={props.id} className="Image" src={props.src} alt={props.title} srcSet={props.srcSet} sizes={sizes} />
    );
};

export default withVerticalSpacing(withContentWrap(Image));
export { PropsType };
